import { useSelector } from 'react-redux';
import StateInterface from '../../redux/types';
import { ShopToClubConfigState } from '../../../common/types/remoteConfig';
import useFeatureToggle from '../useFeatureToggle';
import useUserTracking from './useUserTracking';
import useNeverShowShopToClub from './useNeverShowShopToClub';
import usePromoBarDismissed from './usePromoBarDismissed';
import { HeaderModeType, useLayoutByPage } from 'Client/hooks/useLayoutByPage';

const useShowPromoBarBanner = (): boolean | undefined => {
    const [promoBarDismissedInLastThirtyDays] = usePromoBarDismissed();
    const { clubHeaderBarBanner } = useFeatureToggle();
    const { isRegistered, didLoginFinishOnce } = useUserTracking();
    const [hasDismissCookie] = useNeverShowShopToClub();
    const { headerMode } = useLayoutByPage();
    const promoConfiguration = useSelector<StateInterface, ShopToClubConfigState>(
        state => state.configurations.shopToClub
    );

    const isShopToClubEnabled = promoConfiguration.isEnabled;
    const correctHeaderMode = headerMode !== HeaderModeType.NONE;
    return (
        !hasDismissCookie &&
        !isRegistered &&
        !promoBarDismissedInLastThirtyDays &&
        correctHeaderMode &&
        clubHeaderBarBanner &&
        didLoginFinishOnce &&
        isShopToClubEnabled
    );
};

export default useShowPromoBarBanner;
